<template>
  <div>
    <div class="container" v-if="!$store.getters.comparisonMode">
      <div class="alert bg-white rounded mb-0 shadow">
        <CasinoFilters />
        </div>
      <template v-if="!onlyFilters">
      <div class="row">
           <div
        class="col-12"
        v-if="results.length"
      >
        <CompareBanner />
        <CasinoResultsOrdering />
        <CasinoResults v-bind:results="$store.getters.results" />
      </div>
          </div>
    </template>
    </div>

    <Compare v-else />
  </div>
</template>

<script>
import CasinoFilters from './CasinoFilters';
import CasinoResultsOrdering from './CasinoResultsOrdering';
import CasinoResults from './CasinoResults';
import CompareBanner from './CompareBanner';
import Compare from './Compare';
import store from '../store';

export default {
  name: 'CasinoApp',
  store,
  data: () => {
    return {
      results: [],
      onlyFilters: window.onlyFilters
    };
  },
  methods: {
    formatResults: (results) => {
      const formattedResults = [];
      for (let result of results) {
        const newObj = {
          ...result.casino,
          ...result.managedDomainInfo,
          ...result.countryInfo,
          visible: true,
          compared: false,
        };

        formattedResults.push(newObj);
      }

      return formattedResults;
    },
  },

  async mounted() {
    if(this.onlyFilters) {
      store.commit('setComparisonMode', false)
    }
    let res = await fetch(
      'https://2kadmin.casino2k.com/api/casinos/1?country=Italia',
      {
        method: 'GET',
        headers: {
          'Bearer-Token': 'yb5J12AEAlaEjlIC',
        },
      }
    );
    this.results = store.getters.results.length ? store.getters.results:  this.formatResults(await res.json());


    store.commit(
      'setResults',
      this.results.filter((e) => {
        return e.attivo && e.elencato && e.sponsorizzabile;
      })
    );
  },
  components: {
    CasinoFilters,
    CasinoResultsOrdering,
    CasinoResults,
    CompareBanner,
    Compare,
  },
};
</script>
